import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const adminRoutes = [
  <Route
    key="programlist"
    exact
    path="/programlist"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/admin/pages/ProgramList")}
      />
    )}
  />,
  <Route
    key="programlist-pid"
    exact
    path="/programlist/:pid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/ProgramsUsers")}
      />
    )}
  />,
  <Route
    key="studentlist"
    exact
    path="/studentlist/:pid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/ProgramsStudents")}
      />
    )}
  />,
  <Route
    key="studentprofile"
    exact
    path="/studentprofile/:uid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/StudentProfile")}
      />
    )}
  />,
  <Route
    key="programlistpackage"
    exact
    path="/programlistpackage/:pid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/ProgramsQuestionPackage")}
      />
    )}
  />,
  <Route
    key="users"
    exact
    path="/users/:uid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/UserDetail")}
      />
    )}
  />,
  <Route
    key="mentor-review"
    exact
    path="/mentor-profile/:mentor_id"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/admin/pages/MentorReview")}
      />
    )}
  />,
  <Route
    key="leaderboard-group"
    exact
    path="/leaderboard-group/:program_id/:group_id"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/admin/pages/LeaderboardGroup")}
      />
    )}
  />,
  <Route
    key="mentor-catalog"
    exact
    path="/mentor-catalog"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/admin/pages/CatalogMentor")}
      />
    )}
  />,
  <Route
    key="admin-media"
    exact
    path="/admin/program/:programId/media"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/admin/pages/AdminMedia")}
      />
    )}
  />,
];

export default adminRoutes; 